import React from "react";
import "./Careers.css";

function Careers() {
  return (
    <div className="careers">
      <div className="container">
        <div className="careers_text">
          <h1>Careers</h1>
          <hr />
          <h4>Who We Are?</h4>
          <p>
            We're a small group of passionate professionals who believe the best
            place to start with improving emotional health is with kids. We love
            a good challenge, innovative thinking, and the latest in brain
            research and neuroscience to tackle a growing crisis among
            adolescents. Some of us are tech geeks. Most importantly, we strive
            to make an impact in people's lives through the products we create.
          </p>
          <h4>What It's Like Here?</h4>
          <p>
            YouROK was born out of a desire to help kids grow into emotionally
            healthy adults -- ours included! Feeling happy and inspired every
            day is part of our work philosophy, and we know that enthusiasm for
            what we do makes us more productive, creative, and successful in
            every area of our lives.
          </p>
          <h4>Who We're Looking For?</h4>
          <p>
            We're looking for talented, curious, and collaborative individuals
            who are genuinely excited to go to work each day and make an impact.
            If you think your skill set would complement our team of
            hard-working, creative employees, we want to hear from you!
          </p>
          <h4>How To Apply?</h4>
          <p>
            Please send your resume to{" "}
            <a href="jobs@YouROKapps.com">jobs@YouROKapps.com</a>
          </p>
        </div>
      </div>
    </div>
  );
}

export default Careers;
